import styled from 'styled-components';

import { DefaultThemeSettings } from './DefaultThemes';

export const GradientMode = styled(DefaultThemeSettings)`
  position: absolute;
  right: 0;
  left: 0;
  z-index: 999;

  header.ant-layout-header,
  .search-container-on-mobile {
    background: ${(props) =>
      `linear-gradient(${props.tenantTheme['general-theme'].themeMasterColor}, transparent 110%)`};
    backdrop-filter: blur(3px);
  }

  .search-input {
    background: #323232;
  }

  header.ant-layout-header {
    .icon.sidebar {
      color: #1a1a1a;
    }

    .content-container {
      .site-title h1,
      .anticon-search.icon,
      .course_options,
      ul.gx-header-notifications li,
      ul.gx-header-notifications li i {
        color: #1a1a1a;
      }
    }
  }
`;
